import * as THREE from "three";

function makeTex(draw, w, h) {
  const c = document.createElement("canvas");
  c.width = w;
  c.height = h;
  const g = c.getContext("2d");
  draw(g, w, h);
  const tex = new THREE.CanvasTexture(c);
  tex.anisotropy = 4;
  return tex;
}

function lineDot(g, x, y, r, color, label) {
  g.beginPath();
  g.arc(x, y, r, 0, Math.PI * 2);
  g.fillStyle = color;
  g.fill();
  g.lineWidth = r * 0.22;
  g.strokeStyle = "#ffffff";
  g.stroke();
  g.fillStyle = "#ffffff";
  g.font = `bold ${Math.round(r * 1.1)}px sans-serif`;
  g.textAlign = "center";
  g.textBaseline = "middle";
  g.fillText(label, x, y + 1);
}

export const exitSignTex = () =>
  makeTex(
    (g, w, h) => {
      g.fillStyle = "#0b1d3a";
      g.fillRect(0, 0, w, h);
      g.fillStyle = "#ffffff";
      g.textBaseline = "middle";
      g.textAlign = "left";
      g.font = "bold 64px sans-serif";
      g.fillText("出口", 36, h / 2 - 4);
      g.font = "600 26px sans-serif";
      g.fillText("Exit", 176, h / 2 + 6);
      g.font = "bold 70px sans-serif";
      g.textAlign = "right";
      g.fillText("→", w - 150, h / 2);
      lineDot(g, w - 96, h / 2, 26, "#e0242f", "M");
      lineDot(g, w - 36, h / 2, 26, "#1a5fd0", "T");
    },
    640,
    128
  );

export const stationSignTex = () =>
  makeTex(
    (g, w, h) => {
      g.fillStyle = "#f4f7f8";
      g.fillRect(0, 0, w, h);
      g.fillStyle = "#17a34a";
      g.fillRect(0, h - 26, w, 26);
      g.fillStyle = "#101418";
      g.textAlign = "center";
      g.textBaseline = "middle";
      g.font = "bold 92px sans-serif";
      g.fillText("渋谷", w / 2, 64);
      g.font = "600 30px sans-serif";
      g.fillText("SHIBUYA", w / 2, 134);
      g.font = "26px sans-serif";
      g.textAlign = "left";
      g.fillText("← 表参道", 24, 176);
      g.textAlign = "right";
      g.fillText("恵比寿 →", w - 24, 176);
      lineDot(g, 62, 64, 30, "#1a5fd0", "T");
      lineDot(g, w - 62, 64, 30, "#e0242f", "M");
    },
    640,
    220
  );

export const noSmokingTex = () =>
  makeTex(
    (g, w, h) => {
      g.fillStyle = "#eef2f4";
      g.fillRect(0, 0, w, h);
      g.fillStyle = "#111111";
      g.fillRect(42, h / 2 - 6, 58, 12);
      g.fillStyle = "#ff7a1a";
      g.fillRect(96, h / 2 - 6, 8, 12);
      g.beginPath();
      g.arc(70, h / 2, 46, 0, Math.PI * 2);
      g.lineWidth = 10;
      g.strokeStyle = "#e0242f";
      g.stroke();
      g.beginPath();
      g.moveTo(38, h / 2 - 34);
      g.lineTo(102, h / 2 + 34);
      g.stroke();
      g.fillStyle = "#111111";
      g.textBaseline = "middle";
      g.textAlign = "left";
      g.font = "bold 58px sans-serif";
      g.fillText("禁煙", 140, h / 2 - 12);
      g.font = "600 22px sans-serif";
      g.fillText("NO SMOKING", 142, h / 2 + 34);
    },
    400,
    128
  );

export const ledSignTex = () =>
  makeTex(
    (g, w, h) => {
      g.fillStyle = "#050505";
      g.fillRect(0, 0, w, h);
      g.fillStyle = "#ff9a1f";
      g.textBaseline = "middle";
      g.textAlign = "center";
      g.font = "bold 44px monospace";
      g.fillText("G  ·  NEXT STOP: GUMZ ST", w / 2, h / 2);
      g.fillStyle = "rgba(0,0,0,0.5)";
      for (let y = 0; y < h; y += 4) g.fillRect(0, y, w, 2);
    },
    640,
    80
  );

export function signMesh(tex, w, h, intensity = 0.9) {
  const mat = new THREE.MeshStandardMaterial({
    map: tex,
    emissive: 0xffffff,
    emissiveMap: tex,
    emissiveIntensity: intensity,
    roughness: 0.6,
    side: THREE.DoubleSide,
  });
  return new THREE.Mesh(new THREE.PlaneGeometry(w, h), mat);
}
